import clsx from 'clsx';
import React from 'react';
import styled from 'styled-components';

export const Center = styled.div`
  &:not(.inline) {
    > * {
      margin: 0 auto;
    }
  }
  &.inline {
    text-align: center;
  }
  &.flex {
    display: flex;
    flex-direction: column;
  }
  &.flex-align-center {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

interface ICenter {
  children: React.ReactNode;
  inline?: boolean;
  flex?: boolean;
  flexAlignCenter?: boolean;
  as?: React.ElementType;
}

export default ({ children, inline, flex, flexAlignCenter }: ICenter) => {
  return (
    <Center
      className={clsx(inline && 'inline', flex && 'flex', flexAlignCenter && 'flex-align-center')}>
      {children}
    </Center>
  );
};
